import {
  useManageAlarmTypesInGroup,
  useAlarmTypesByName,
} from '@hakimo-ui/hakimo/data-access';
import { MultiSelectAsync } from '@hakimo-ui/hakimo/ui-elements';
import { currentTenantAtom, eventTracker, toast } from '@hakimo-ui/hakimo/util';
import { Button, Modal, Selectable } from '@hakimo-ui/shared/ui-base';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

export type AddAlarmTypesToGroupModalProps = {
  alarmTypeGroupId: number;
  onClose: () => void;
};

export function AddAlarmTypesToGroupModal(
  props: AddAlarmTypesToGroupModalProps
) {
  const { alarmTypeGroupId, onClose } = props;
  const [selectedAlarmTypes, setSelectedAlarmTypes] = useState<Selectable[]>(
    []
  );
  const getAlarmTypesByName = useAlarmTypesByName();
  const currentTenant = useAtomValue(currentTenantAtom);

  const getAlarmTypesByNameWithTenant = (name: string) => {
    if (!currentTenant?.id) {
      return Promise.resolve([]);
    }
    return getAlarmTypesByName(name, currentTenant.id);
  };

  const mutation = useManageAlarmTypesInGroup(alarmTypeGroupId, () => {
    toast(
      `Alarm Type${
        selectedAlarmTypes.length > 1 ? 's' : ''
      } added to Alarm Type Group successfully`,
      { type: 'success' }
    );
    onClose();
  });

  const onSubmit = () => {
    mutation.mutate({
      operation: 'add',
      alarm_types: selectedAlarmTypes.map((at) => at.id),
    });
  };

  const actions = (
    <>
      <Button
        variant="primary"
        onClick={onSubmit}
        disabled={selectedAlarmTypes.length === 0 || mutation.isLoading}
        onSideEffect={eventTracker('submit_add_alarm_types_to_group')}
        loading={mutation.isLoading}
      >
        Add to Group
      </Button>
      <Button
        onClick={onClose}
        onSideEffect={eventTracker('cancel_add_alarm_types_to_group')}
      >
        Cancel
      </Button>
    </>
  );

  return (
    <Modal
      title="Add Alarm Types to Group"
      open
      onClose={onClose}
      footer={actions}
    >
      <div className="w-[36rem] space-y-4 p-8">
        <MultiSelectAsync
          label="Alarm Types"
          value={selectedAlarmTypes}
          onChange={setSelectedAlarmTypes}
          onChangeQuery={getAlarmTypesByNameWithTenant}
          displayValue={(item) => item?.name || ''}
          id={(item) => item.id}
        />
      </div>
    </Modal>
  );
}

export default AddAlarmTypesToGroupModal;
